import { Swiper } from 'swiper';
import { FreeMode, Navigation } from 'swiper/modules';

export class CatalogSubcategories {
	private element: HTMLElement;
	private slider: Swiper;
	private sliderOptions = {
		modules: [FreeMode, Navigation],
		slidesPerView: 'auto',
		navigation: {
			prevEl: '.catalog-subcategories__button--prev',
			nextEl: '.catalog-subcategories__button--next',
		}
	};

	constructor(element) {
		if (!element) return;
		this.element = element;
		this.init();
	}

	init = () => {
		this.slider = new Swiper(this.element, this.sliderOptions);
	};
}
